// import React, { useEffect, useState, useMemo, useRef, useCallback } from "react";
// import exiticon from "../assets/socialglass/exit-icon.png";
// import SocialMediaFeed from "../routes/SocialMediaFeed";
// import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { decryptfromHEX } from "../routes/encodedecode";
// import { set } from "date-fns";

// const ItemButton = ({ label }) => {
//   return (
//     <div className="flex items-center justify-center whitespace-nowrap rounded-full bg-[#F6DADA] px-[8px] py-[4px] text-[12px] text-black">
//       {label}
//     </div>
//   );
// };

// function ProgressIndicator() {
//   return (
//     <div className="mt-0 flex h-[5px] w-[135px] shrink-0 rounded-[100px] bg-black" />
//   );
// }

// // FilterBar component
// function FilterBar({
//   categories,
//   selectedCategories,
//   onToggleCategory,
//   onClearAll,
//   applyFilter,
//   isDropdownOpen,
//   setIsDropdownOpen,
// }) {
//   return (
//     <div className="relative mx-auto w-full">
//       {/* Clickable filter header bar */}
//       <div
//         className="mb-2 mt-2 flex min-h-12 w-full cursor-pointer items-center justify-between gap-10 whitespace-nowrap rounded-sm border border-solid border-[color:var(--Overlays-Default,rgba(0,0,0,0.20))] bg-neutral-100 px-4 py-2 text-center text-sm leading-6 text-zinc-600"
//         onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//       >
//         {selectedCategories.length > 0 ? (
//           <div className="flex flex-wrap gap-2">
//             {selectedCategories.map((cat) => (
//               <ItemButton key={cat} label={cat} />
//             ))}
//           </div>
//         ) : (
//           <span className="my-auto self-stretch">FILTER</span>
//         )}

//         <img
//           src="https://cdn.builder.io/api/v1/image/assets/TEMP/413a913c467012c1a288dd5ed3c9fed78bad05b8?placeholderIfAbsent=true&apiKey=b7b395ae03b14b728868337a9d3fb267"
//           className="my-auto aspect-square w-6 shrink-0 self-stretch object-contain"
//           alt="Filter icon"
//         />
//       </div>

//       {/* Dropdown menu for selecting categories */}
//       {isDropdownOpen && (
//         <div className="relative w-full px-2.5 md:px-0">
//           <div className="group absolute left-0 top-[100%] z-50 mt-2 h-[280px] w-full overflow-y-auto rounded-sm border border-gray-200 bg-[#F8F7F7]">
//             <div className="flex flex-col p-2">
//               <div className="mb-4 flex items-center justify-between">
//                 <button
//                   className="text-sm text-gray-600 hover:text-gray-800"
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     onClearAll();
//                   }}
//                 >
//                   Clear all
//                 </button>
//                 <button
//                   className="text-sm font-medium text-red-500 hover:text-red-700"
//                   onClick={() => applyFilter()}
//                 >
//                   Apply
//                 </button>
//               </div>

//               {categories.map((cat) => {
//                 const isChecked = selectedCategories.includes(cat.label);
//                 return (
//                   <label
//                     key={cat.value}
//                     className="-mx-2 flex w-[calc(100%+16px)] cursor-pointer items-center gap-3 px-2 py-2 transition-colors duration-300 ease-in-out hover:bg-red-100"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     <input
//                       type="checkbox"
//                       checked={isChecked}
//                       onChange={() => onToggleCategory(cat.label)}
//                       className="h-5 w-5 rounded border-2 border-gray-300 accent-red-500 focus:ring-0"
//                     />
//                     <span className="text-sm text-gray-800">{cat.label}</span>
//                   </label>
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// function SocialGlassFeed(props) {
//   const navigate = useNavigate();
//   document.title = "Social Glass AI Feed";

//   const [categories, setCategories] = useState([]);
//   const [categoryToPostMap, setCategoryToPostMap] = useState({});
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [hasMore, setHasMore] = useState(true);
//   const limit = 5;

//   const loaderRef = useRef(null);
//   const offsetRef = useRef(0);
//   const isLoadingRef = useRef(false);
//   const filteredOffsetRef = useRef(0);
//   const isFilteredLoadingRef = useRef(false);

//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [posts, setPosts] = useState([]);
//   const [allPosts, setAllPosts] = useState([]); // Holds full unfiltered posts
//   const [filteredPosts, setFilteredPosts] = useState([]);
//   const [hasMoreFiltered, setHasMoreFiltered] = useState(true);

//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const encrypted = queryParams.get("p");
//   let orgID = null;

//   if (encrypted) {
//     try {
//       const decrypted = decryptfromHEX(encrypted);
//       orgID = JSON.parse(decrypted).orgID;
//     } catch (err) {
//       console.error("Failed to decrypt orgID:", err);
//     }
//   }

//   const processCategories = useCallback((postData) => {
//     const newCategoryToPostMap = {};
//     const categories = [];

//     postData.forEach((post) => {
//       if (!post.socialglass_categories || post.socialglass_categories[0] === null) return;

//       post.socialglass_categories.forEach((category) => {
//         if (category && !newCategoryToPostMap[category]) {
//           newCategoryToPostMap[category] = [];
//           categories.push({ label: category, value: category });
//         }
//         if (category) newCategoryToPostMap[category].push(post);
//       });
//     });

//     return { newCategoryToPostMap, categories };
//   }, []);

//   const memoizedCategories = useMemo(() => processCategories(allPosts), [allPosts]);

//   useEffect(() => {
//     if (memoizedCategories) {
//       setCategoryToPostMap(memoizedCategories.newCategoryToPostMap);
//       setCategories(memoizedCategories.categories);
//     }
//   }, [memoizedCategories]);

//   // Initial fetch of posts
//   useEffect(() => {
//     if (hasMore) {
//       fetchOrgFeed(offsetRef.current);
//     }
//   }, [hasMore]);

//   useEffect(() => {
//     const observer = new IntersectionObserver((entries) => {
//       if (entries[0].isIntersecting) {
//         if (selectedCategories.length > 0) {
//           loadMoreFilteredPosts();
//         } else {
//           loadMoreUnfilteredPosts();
//         }
//       }
//     }, { threshold: 1 });

//     const loader = loaderRef.current;
//     if (loader) observer.observe(loader);

//     return () => {
//       if (loader) observer.unobserve(loader);
//     };
//   }, [hasMore, posts, selectedCategories, hasMoreFiltered, filteredPosts]);

//   const fetchOrgFeed = async (offset) => {
//     try {
//       const res = await axios.get("https://genz-staging.feeltiptop.com/api/social_glass/feedDisplay", {
//         params: { orgID, offset, limit },
//       });

//       const postData = res.data;
//       console.log("Posts from backend: ", postData);

//       if (postData.length < limit) {
//         setHasMore(false); // No more posts
//       }

//       if (postData.length > 0) {
//         setPosts((prev) => [...prev, ...postData]);
//         setAllPosts((prev) => [...prev, ...postData]);
//       }
//     } catch (err) {
//       console.error("Error loading feed:", err);
//     }
//   };

//   const loadMoreUnfilteredPosts = () => {
//     if (hasMore && !isLoadingRef.current) {
//       isLoadingRef.current = true;
//       offsetRef.current += limit;
//       fetchOrgFeed(offsetRef.current).finally(() => {
//         isLoadingRef.current = false;
//       });
//     }
//   };

//   const loadMoreFilteredPosts = () => {
//     if (hasMoreFiltered && !isFilteredLoadingRef.current) {
//       isFilteredLoadingRef.current = true;
//       const filteredPostsArray = Array.from(
//         selectedCategories.reduce((postsSet, category) => {
//           const postsForCategory = categoryToPostMap[category] || [];
//           postsForCategory.forEach((post) => postsSet.add(post));
//           return postsSet;
//         }, new Set())
//       );

//       const nextPosts = filteredPostsArray.slice(
//         filteredOffsetRef.current,
//         filteredOffsetRef.current + limit
//       );
//       setPosts((prev) => [...prev, ...nextPosts]);
//       filteredOffsetRef.current += limit;
//       setHasMoreFiltered(filteredOffsetRef.current < filteredPostsArray.length);
//       isFilteredLoadingRef.current = false;
//     }
//   };

//   const applyFilter = () => {
//     const filteredPostsSet = selectedCategories.length
//       ? selectedCategories.reduce((postsSet, category) => {
//           const postsForCategory = categoryToPostMap[category] || [];
//           postsForCategory.forEach((post) => postsSet.add(post));
//           return postsSet;
//         }, new Set())
//       : new Set(allPosts); // Base unfiltered set

//     const filteredPostsArray = Array.from(filteredPostsSet);
//     console.log("Filtered Posts: ", filteredPostsArray)
//     setPosts(filteredPostsArray.slice(0, limit));
//     filteredOffsetRef.current = limit;
//     setHasMoreFiltered(filteredPostsArray.length > limit);
//     setIsDropdownOpen(false);
//   };

//   const handleClearAll = () => {
//     setSelectedCategories([]);
//     setPosts(allPosts); // Restore full unfiltered list
//     console.log("ALL POSTS after clickin clear all: ", allPosts)
//     setIsDropdownOpen(false);
//     filteredOffsetRef.current = 0;
//     setHasMoreFiltered(true);
//   };

//   const handleToggleCategory = (value) => {
//     setSelectedCategories((prev) =>
//       prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
//     );
//   };

//   return (
//     <main className="mx-auto flex w-full max-w-[480px] flex-col items-center overflow-hidden bg-white pb-6 pt-2">
//       {/* Header */}
//       <header className="flex w-[345px] items-center justify-between px-2.5">
//         <img
//           src="https://cdn.builder.io/api/v1/image/assets/TEMP/910a7ef10484d9d90c0c23c8d234657476361b04?placeholderIfAbsent=true&apiKey=b7b395ae03b14b728868337a9d3fb267"
//           className="aspect-square w-[42px] object-contain"
//           alt="Logo"
//         />
//       </header>

//       <hr className="mt-2 w-[325px] border border-solid border-neutral-200 bg-neutral-200" />

//       {/* Category Bar and Feed */}
//       <div className="w-[346px] px-2.5">
//         <FilterBar
//           categories={categories}
//           selectedCategories={selectedCategories}
//           onToggleCategory={handleToggleCategory}
//           onClearAll={handleClearAll}
//           applyFilter={applyFilter}
//           isDropdownOpen={isDropdownOpen}
//           setIsDropdownOpen={setIsDropdownOpen}
//         />

//         <section className="z-10 mt-3 w-full space-y-4">
//           <SocialMediaFeed posts={posts} />
//           {(selectedCategories.length > 0 ? hasMoreFiltered : hasMore) && posts.length > 0 && (
//             <div ref={loaderRef} className="h-10 text-center">
//               Loading...
//             </div>
//           )}
//         </section>
//       </div>

//       <ProgressIndicator />
//     </main>
//   );
// }

// export default SocialGlassFeed;

import React, { useEffect, useState } from "react";
import exiticon from "../assets/socialglass/exit-icon.png";
import SocialMediaFeed from "../routes/SocialMediaFeed";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { decryptfromHEX } from "../routes/encodedecode";
import { set } from "date-fns";

const ItemButton = ({ label }) => {
  return (
    <div className="flex items-center justify-center whitespace-nowrap rounded-full bg-[#F6DADA] px-[8px] py-[4px] text-[12px] text-black">
      {label}
    </div>
  );
};

function ProgressIndicator() {
  return (
    <div className="mt-0 flex h-[5px] w-[135px] shrink-0 rounded-[100px] bg-black" />
  );
}

// FilterBar component
function FilterBar({
  categories,
  selectedCategories,
  onToggleCategory,
  onClearAll,
  applyFilter,
  isDropdownOpen,
  setIsDropdownOpen,
}) {
  return (
    <div className="relative mx-auto w-full">
      {/* Clickable filter header bar */}
      <div
        className="mb-2 mt-2 flex min-h-12 w-full cursor-pointer items-center justify-between gap-10 whitespace-nowrap rounded-sm border border-solid border-[color:var(--Overlays-Default,rgba(0,0,0,0.20))] bg-neutral-100 px-4 py-2 text-center text-sm leading-6 text-zinc-600"
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        {selectedCategories.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {selectedCategories.map((cat) => (
              <ItemButton key={cat} label={cat} />
            ))}
          </div>
        ) : (
          <span className="my-auto self-stretch">FILTER</span>
        )}

        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/413a913c467012c1a288dd5ed3c9fed78bad05b8?placeholderIfAbsent=true&apiKey=b7b395ae03b14b728868337a9d3fb267"
          className="my-auto aspect-square w-6 shrink-0 self-stretch object-contain"
          alt="Filter icon"
        />
      </div>

      {/* Dropdown menu for selecting categories */}
      {isDropdownOpen && (
        <div className="relative w-full px-2.5 md:px-0">
          <div className="group absolute left-0 top-[100%] z-50 mt-2 h-[280px] w-full overflow-y-auto rounded-sm border border-gray-200 bg-[#F8F7F7]">
            <div className="flex flex-col p-2">
              <div className="mb-4 flex items-center justify-between">
                <button
                  className="text-sm text-gray-600 hover:text-gray-800"
                  onClick={(e) => {
                    e.stopPropagation();
                    onClearAll();
                  }}
                >
                  Clear all
                </button>
                <button
                  className="text-sm font-medium text-red-500 hover:text-red-700"
                  onClick={() => applyFilter()}
                >
                  Apply
                </button>
              </div>

              {categories.map((cat) => {
                const isChecked = selectedCategories.includes(cat.label);

                return (
                  <label
                    key={cat.value}
                    className="-mx-2 flex w-[calc(100%+16px)] cursor-pointer items-center gap-3 px-2 py-2 transition-colors duration-300 ease-in-out hover:bg-red-100"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={() => onToggleCategory(cat.label)}
                      className="h-5 w-5 rounded border-2 border-gray-300 accent-red-500 focus:ring-0"
                    />
                    <span className="text-sm text-gray-800">{cat.label}</span>

                    <span className="absolute right-2 text-xs text-gray-500 md:right-4">
                      {cat.count} {cat.count > 1 ? "posts" : "post"}
                    </span>
                  </label>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Main SocialGlassFeed component
function SocialGlassFeed(props) {
  const navigate = useNavigate();
  document.title = "Social Glass AI Feed";

  const [categories, setCategories] = useState([]);
  const [categoryToPostMap, setCategoryToPostMap] = useState({}); // state for categoryToPostMap
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [posts, setPosts] = useState([]);
  const [postsBackup, setPostsBackup] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encrypted = queryParams.get("p");
  let orgID = null;
  if (encrypted) {
    try {
      const decrypted = decryptfromHEX(encrypted);
      const parsed = JSON.parse(decrypted);
      orgID = parsed.orgID;
      console.log("Decrypted orgID:", orgID);
    } catch (err) {
      console.error("Failed to decrypt orgID from URL:", err);
    }
  }

  console.log("Location state:", location.state);

  useEffect(() => {
    const fetchOrgFeed = async () => {
      try {
        const res = await axios.get("https://genz-staging.feeltiptop.com/api/social_glass/feedDisplay", {
          params: { orgID },
        });
        console.log("Feed data:", res.data);
        const postData = res.data;
        console.log("Post data structure:", postData);
        setPosts(postData);
        setPostsBackup(postData); // Backup of all posts, memoize later

        // Map of inverted categories to posts for faster filtering
        const newCategoryToPostMap = {}; // Temporary map to collect data
        const categories = [];
        const categoriesPlaceholder = {};
        postData.forEach((post) => {
          if (
            !post.socialglass_categories ||
            post.socialglass_categories[0] === null
          )
            return; // Skip if no categories
          post.socialglass_categories.forEach((category) => {
            if (!newCategoryToPostMap[category] && category !== null) {
              newCategoryToPostMap[category] = [];
              categoriesPlaceholder[category] = {
                label: category,
                value: category,
                count: 0,
              };
              // categories.push({
              //   label: category,
              //   value: category,
              // }); // Collect unique categories
            }
            if (category !== null) categoriesPlaceholder[category].count += 1;
            newCategoryToPostMap[category].push(post);
          });
        });

        // Now set the state for categoryToPostMap
        setCategoryToPostMap(newCategoryToPostMap);
        Object.keys(categoriesPlaceholder).forEach((key) => {
          categories.push(categoriesPlaceholder[key]);
        });
        console.log("Categories after processing:", categories);

        //sort the categories by count
        categories.sort((a, b) => b.count - a.count);

        setCategories(categories);
        // setCategories(categories);
      } catch (err) {
        console.error("Error loading feed:", err);
      }
    };

    fetchOrgFeed();
  }, []);

  const applyFilter = () => {
    const postsSet = new Set();

    selectedCategories.forEach((category) => {
      const postsForCategory = categoryToPostMap[category] || [];
      postsForCategory.forEach((post) => postsSet.add(post));
    });

    const filteredPosts = Array.from(postsSet);
    console.log("Filtered posts:", filteredPosts);

    setIsDropdownOpen(false);
    setPosts(filteredPosts.length > 0 ? filteredPosts : postsBackup);
  };

  // Handle toggling of a category
  const handleToggleCategory = (value) => {
    setSelectedCategories((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  // Handle clearing all selected categories
  const handleClearAll = () => {
    setSelectedCategories([]);
    setPosts(postsBackup); // Reset to all posts
  };

  const handleLogout = () => {
    axios
      .post(
        "https://genz-staging.feeltiptop.com/api/user/logout",
        {},
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        },
      )
      .then((response) => {
        props.removeToken();
        localStorage.removeItem("authToken");
        localStorage.removeItem("feedState");
        navigate("/");
      })
      .catch((error) => {
        console.error("Logout error:", error);
      });
  };

  return (
    <main className="mx-auto flex w-[403px] flex-col items-center overflow-hidden bg-white pb-6 pt-2">
      {/* Header */}
      <header className="flex w-full items-center justify-between px-2.5">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/910a7ef10484d9d90c0c23c8d234657476361b04?placeholderIfAbsent=true&apiKey=b7b395ae03b14b728868337a9d3fb267"
          className="aspect-square w-[42px] object-contain"
          alt="Logo"
        />
        {/* <img
          onClick={handleLogout}
          className="h-6 w-6 cursor-pointer"
          src={exiticon}
          alt="Logout"
        /> */}
      </header>

      {/* Divider */}
      <hr className="mt-2 w-full border border-solid border-neutral-200 bg-neutral-200" />

      {/* Category Bar and Feed */}
      <div className="w-full px-0">
        {/* Filter Bar */}
        <FilterBar
          categories={categories}
          selectedCategories={selectedCategories}
          onToggleCategory={handleToggleCategory}
          onClearAll={handleClearAll}
          applyFilter={applyFilter}
          isDropdownOpen={isDropdownOpen}
          setIsDropdownOpen={setIsDropdownOpen}
        />

        {/* Posts list */}
        <section className="z-10 mx-0 mt-3 w-fit space-y-4">
          <SocialMediaFeed posts={posts} />
        </section>
      </div>

      <ProgressIndicator />
    </main>
  );
}

export default SocialGlassFeed;
